import {
  ShoppingCart, TrendingUp, Package, FileText, DollarSign, Wallet,
  FolderKanban, Warehouse, Users, Building2, Boxes, Blocks, Truck,
} from 'lucide-react';

/** Odoo-style launchpad tiles → each navigates into a module landing page. */
export const LAUNCHPAD_MODULES = [
  { id: 'p2p', label: 'Procure-to-Pay', icon: ShoppingCart, path: '/p2p/dashboard' },
  { id: 'otc', label: 'Order-to-Cash', icon: TrendingUp, path: '/otc/dashboard' },
  { id: 'inventory', label: 'Inventory', icon: Package, path: '/inventory/dashboard' },
  { id: 'presales', label: 'Pre-Sales', icon: FileText, path: '/presales/inquiries' },
  { id: 'ar', label: 'Accounts Receivable', icon: DollarSign, path: '/ar/aging-report' },
  { id: 'ap', label: 'Accounts Payable', icon: Wallet, path: '/ap/aging' },
  { id: 'project', label: 'Project Systems', icon: FolderKanban, path: '/ps' },
  { id: 'warehouse', label: 'Warehouse', icon: Warehouse, path: '/warehouse/shipments' },
  { id: 'customer', label: 'Customer Master', icon: Users, path: '/customer-master' },
  { id: 'vendor', label: 'Vendor Master', icon: Building2, path: '/vendor-master' },
  { id: 'material', label: 'Material Master', icon: Boxes, path: '/material-master' },
  { id: 'lowcode', label: 'Low-Code', icon: Blocks, path: '/config/doctype-builder' },
];

export const QUICK_ACTIONS = [
  { label: 'Create Sales Order', icon: TrendingUp, path: '/otc/sales-orders/create' },
  { label: 'Create Purchase Order', icon: ShoppingCart, path: '/p2p/po-create' },
  { label: 'Create Customer', icon: Users, path: '/customer-creation' },
  { label: 'Create Material', icon: Package, path: '/material-creation' },
  { label: 'Post Goods Receipt', icon: Truck, path: '/p2p/gr-create' },
  { label: 'Record Payment', icon: DollarSign, path: '/ar/payments/create' },
];

/** Orange-derived chart palette (locked theme). */
export const CHART_COLORS = {
  revenue: '#EA580C',
  donut: ['#EA580C', '#F97316', '#FDBA74', '#334155', '#94A3B8', '#FB923C'],
  aging: ['#FDBA74', '#FB923C', '#F97316', '#EA580C', '#9A3412'],
};

export const formatCurrency = (value) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(value || 0);

export const formatCompact = (value) => {
  const n = value || 0;
  if (Math.abs(n) >= 1000) return `$${(n / 1000).toFixed(1)}K`;
  return `$${n.toFixed(0)}`;
};
